module.exports = __webpack_public_path__ + "static/nipcbestfriendsmain-9e1e87569922db92ffc011c67147e60f.jpeg";